var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    '_side-view',
    {
      '_side-view--collapse': _vm.screenxs ? false : _vm.collapse
    }
  ]},[_c('div',{staticClass:"_side-view__inner"},[_c('div',{staticClass:"_side-view__logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":_vm.logo,"alt":"YOLOLIV"}})])],1),_c('y-menu',{attrs:{"router":"","default-active":_vm.active,"collapse":_vm.screenxs ? false : _vm.collapse,"collapse-transition":false}},[_c('tree-menu',{attrs:{"data":_vm.menuList,"active":_vm.active,"subAcitve":_vm.subAcitve,"collapse":_vm.collapse}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }